module.exports = __webpack_public_path__ + "0936823295b56c6d6105abbcb091d7fd.jpg";